/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './ag-legend.scss';

/* eslint-disable import/no-unresolved, import/default */

import legendTemplate from './ag-legend.tpl.html';

/* eslint-enable import/no-unresolved, import/default */


export default angular.module('agrolog.client.legend', [])
    .directive('agLegend', Legend)
    .name;

/*@ngInject*/
function Legend($compile, $templateCache) {

    var linker = function (scope, element) {
        var template = $templateCache.get(legendTemplate);
        element.html(template);

        scope.toggleHideMaxThreshold = function() {
            scope.legendConfig.maxThresholdHidden = !scope.legendConfig.maxThresholdHidden;
        };

        scope.toggleHideMinThreshold = function() {
            scope.legendConfig.minThresholdHidden = !scope.legendConfig.minThresholdHidden;
        };

        scope.toggleHideData = function(index) {
            scope.legendData.keys[index].dataKey.hidden = !scope.legendData.keys[index].dataKey.hidden;
        };

        $compile(element.contents())(scope);

    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            legendConfig: '=',
            legendData: '='
        }
    };
}
